// import useCommonModal from '@/compositions/useCommonModal';
import { useMutation } from '@vue/apollo-composable';
import schemaGql from '@/api/schemas/item.graphql';

const useSchemaControlActions = (props, context, entity) => {
  // const modalCompositionV2 = useCommonModal();

  const { mutate: deleteSchemaControlMutation } = useMutation(
    schemaGql.deleteSchemaControl
  );

  const deleteSchemaControl = (raw, cb) => {
    deleteSchemaControlMutation({
      input: {
        id: raw.id
      }
    }).then(() => {
      if (cb) cb();
    });
  };

  return {
    deleteSchemaControl
  };
};

export default useSchemaControlActions;
